module.exports = __webpack_public_path__ + "static/media/house.327e246f.svg";